<template>
  <div class="print">
    <div class="page__header page__header-inside">
      <router-link to="/main" class="page__header_title">
        ЭТО<b>ПРОСЧЕТ</b>
      </router-link>

      <PrintManager />

      <div class="page__header_info">
        Заявка #{{ formatOrder
        }}<span
          >-
          <span class="page__header_name">{{ extra }}</span>
        </span>
        Для
        <span class="page__header_name">{{ user }}</span>
        от {{ time }}
      </div>
    </div>

    <template v-if="currentOrder">
      <!--      <PrintItem-->
      <!--        v-for="item in currentOrder.list"-->
      <!--        :key="item.name"-->
      <!--        :currentItem="item"-->
      <!--      />-->
      <OfferItem
        v-for="item in currentOrder.list"
        :key="item.name"
        :currentItem="item"
      />
    </template>

    <p class="hide-print">
      <button type="button" @click="toggleText" class="btn btn-small ">
        Показать/Спрятать текст
      </button>
    </p>
    <div v-if="isShowText">
      Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quisquam,
      repudiandae!
    </div>
  </div>
</template>

<script>
import wNumb from "wnumb";
import PrintItem from "@/components/Print-item";
import PrintManager from "@/components/Print-manager";
import OfferItem from "@/components/Offer-item";

export default {
  name: "Offer",
  // eslint-disable-next-line vue/no-unused-components
  components: { OfferItem, PrintManager, PrintItem },
  data() {
    return {
      isOpenDetails: false,
      isShowText: false
    };
  },
  computed: {
    manager() {
      return this.$store.getters.manager;
    },
    currentOrder() {
      return this.$store.getters.currentOrder;
    },
    user() {
      return this.currentOrder?.user;
    },
    time() {
      return this.currentOrder?.time;
    },
    extra() {
      return this.currentOrder?.extra;
    },
    formatOrder() {
      return wNumb({
        thousand: "-"
      }).to(this.currentOrder?.number ?? 0);
    }
  },
  methods: {
    toggleText() {
      this.isShowText = !this.isShowText;
    }
  }
};
</script>
